import React, { useEffect, useState } from "react";
import "./index.scoped.css";
import {
  getCasinoBetsAPI,
  getCasinoExposureAPI,
  getCasinoLastTenResultAPI,
  getCasinoOddsAPI,
} from "../../service/casino";
import { useQuery } from "react-query";
import CasinoVideo from "./components/CasinoVideo";
import Timer from "./components/Timer";
import {
  CARD_ARRAY,
  cardArray,
  CASINO_VIDEO,
  getCasinoPlExposureByRunner,
  getOddForEntity,
  setBet,
} from "./CasinoGeneric";
import PlaceBet from "./components/PlaceBet";
import { useDispatch } from "react-redux";
import PlacedBet from "./components/PlacedBet";
import CasinoPage from "./components/CasinoPage";
import { useLocation } from "react-router-dom";

export default function SicBo2() {
  const location = useLocation();
  var GAME_ID = location.pathname.split("/");
  GAME_ID = GAME_ID[GAME_ID.length - 1];
  // const GAME_ID = "AAA";
  // const VIDEO_ID = CASINO_VIDEO.amarAkbarAnthony;
  const VIDEO_ID = "sicbo2"
  const dispatch = useDispatch();
  const [casinoPlData, setCasinoPlData] = useState([]);

  const dicePairs = [
    [1, 2],
    [1, 3],
    [1, 4],
    [1, 5],
    [1, 6],
    [2, 3],
    [2, 4],
    [2, 5],
    [2, 6],
    [3, 4],
    [3, 5],
    [3, 6],
    [4, 5],
    [4, 6],
    [5, 6],
  ];

  const casinoData = useQuery(
    "getCasinoOdds",
    () => getCasinoOddsAPI(GAME_ID),
    {
      refetchInterval: 800,
    }
  );

  const getPlExposure = async () => {
    const { response } = await getCasinoExposureAPI(
      casinoData?.data?.response?.marketId
    );
    setCasinoPlData(response);
  };
  useEffect(() => {
    if (casinoData?.data?.response?.marketId) {
      let interval = setInterval(() => {
        getPlExposure();
      }, 2000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [casinoData?.data?.response?.marketId]);

  return (
    <CasinoPage
      casino={casinoData?.data}
      VIDEO_ID={VIDEO_ID}
      // VIDEO_ID={GAME_ID}
      GAME_ID={GAME_ID}
    // VIDEO_ID={CASINO_VIDEO.thirtyTwoCardB}
    //  VIDEO_ID={GAME_ID}
    // GAME_ID={GAME_ID}
    // shortName={"cards32a cards32b"}
    // gameName={"CARDS 32B"}
    >
      {/* <div className="center-main-container casino-page"> */}
      {/* <div className="center-container"> */}
      {/* <div className="casino-page-container sicbo"> */}
      {/* <div className="casino-header"> */}
      {/* <span className="casino-name">
            Sic Bo 2
            <a className="ms-1">
              <small>Rules</small>
            </a>
          </span>
          <span className="casino-rid d-none d-xl-inline-block">
            <small>
              Round ID: <span>158250430213450</span>
            </small>
          </span> */}
      {/* </div> */}
      {/* <div className="casino-title-header-mobile d-xl-none"> */}
      {/* <ul className="nav nav-tabs menu-tabs">
            <li className="nav-item">
              <div className="nav-link active">Game</div>
            </li>
            <li className="nav-item">
              <div className="nav-link">Placed Bet (0)</div>
            </li>
          </ul>
          <div className="pe-2">
            <span className="casino-rid">
              Round ID: <span>158250430213450</span>
            </span>
          </div> */}
      {/* </div> */}
      {/* <div className=""> */}
      {/* <div className="casino-video">
            <div className="video-box-container">
              <div className="casino-video-box">
              </div>
            </div>
            <div className="sicbo-middle">
              <div
                className={`sicbo-middle-small sicbo-square-box ${
                  casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                }`}
                onClick={() =>
                  setBet(
                    casinoData?.data?.response?.oddDetailsDTOS?.[0]?.runnerName,
                    casinoData,
                    dispatch,
                    "back"
                  )
                }
              >
                <div>
                  {casinoData?.data?.response?.oddDetailsDTOS?.[0]?.runnerName}
                </div>
                <div className="sicbo-box-value">4-10</div>
              </div>
              <div className="sicbo-middle-midle">
                <div className="sicbo-middle-top-row">
                  <div
                    className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${
                      casinoData?.data?.response?.autoTime < 5
                        ? "suspended-box"
                        : ""
                    }`}
                    onClick={() =>
                      setBet(
                        casinoData?.data?.response?.oddDetailsDTOS?.[3]
                          ?.runnerName,
                        casinoData,
                        dispatch,
                        "back"
                      )
                    }
                  >
                    <div>
                      {
                        casinoData?.data?.response?.oddDetailsDTOS?.[3]
                          ?.runnerName
                      }
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">0</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">2</div>
                    </div>
                  </a>
                </li>
              </ul>
              <ul className="flip play">
                <li className="flip-clock-before">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">4</div>
                    </div>
                  </a>
                </li>
                <li className="flip-clock-active">
                  <a href="#">
                    <div className="up">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                    <div className="down">
                      <div className="shadow" />
                      <div className="inn">3</div>
                    </div>
                  </a>
                </li>
              </ul>
            </div> */}
      <div className="casino-detail">
        <div className="casino-table">
          <div className="d-none d-xl-block">
            <div className="sicbo-top">
              <div className="sicbo-top-box sicbo-title-box">
                1:1 Lose to Any Triple
              </div>
              <div className="sicbo-top-box sicbo-title-box">30:1</div>
              <div className="sicbo-top-box sicbo-title-box">
                1:1 Lose to Any Triple
              </div>
            </div>
            <div className="sicbo-middle">
              <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                ? "suspended-box"
                : ""
                }`}>
                <div>Snall</div>
                <div

                  onClick={() =>
                    setBet("Smalll", casinoData, dispatch, "back")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("BIG", casinoData, true)}
                  </span>
                </div>
              </div>
              <div className="sicbo-middle-midle">
                <div className="sicbo-middle-top-row">
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>ODD</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>4</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>5</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>6</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>7</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>8</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>9</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>10</div>
                    <div

                      onClick={() =>
                        setBet("ODD", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("ODD", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Any Triple</div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>11</div>
                    <div

                      onClick={() =>
                        setBet("Triple 1", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Triple 1", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>12</div>
                    <div

                      onClick={() =>
                        setBet("Triple 1", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Triple 1", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>13</div>
                    <div

                      onClick={() =>
                        setBet("Triple 3", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Triple 3", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>14</div>
                    <div

                      onClick={() =>
                        setBet("Triple 4", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Triple 4", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>15</div>
                    <div

                      onClick={() =>
                        setBet("Triple 5", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Triple 5", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>16</div>
                    <div

                      onClick={() =>
                        setBet("Triple 6", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Triple 6", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>17</div>
                    <div

                      onClick={() =>
                        setBet("Triple 7", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Triple 7", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>EVEN</div>
                    <div

                      onClick={() =>
                        setBet("Even", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Even", casinoData, true)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="sicbo-middle-middle-row">
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      <span>1:1 on Sinlge</span>
                      <span>2:1 on Double</span>
                      <span>3:1 on Tripple</span>
                    </div>
                    <div className="sicbo-cube-box-group">
                      <div className={`sicbo-cube-box sicbo-square-box sicbo-cube-single ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""}`}>
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                      </div>
                      <div className={`sicbo-cube-box sicbo-square-box sicbo-cube-single ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""}`}>
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                      </div>
                      <div className={`sicbo-cube-box sicbo-square-box sicbo-cube-single ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""}`}>
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className={`sicbo-cube-box sicbo-square-box sicbo-cube-single ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""}`}>
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className={`sicbo-cube-box sicbo-square-box sicbo-cube-single ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""}`}>
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className={`sicbo-cube-box sicbo-square-box sicbo-cube-single ${casinoData?.data?.response?.autoTime < 5 ? "suspended-box" : ""}`}>
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                    </div>

                  </div>
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      8:1 Double
                    </div>
                    <div className="sicbo-cube-box-group">
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      150:1 Each Tripple
                    </div>
                    <div className="sicbo-cube-box-group">
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                ? "suspended-box"
                : ""
                }`}>
                <div>BIG</div>
                <div

                  onClick={() =>
                    setBet("BIG", casinoData, dispatch, "back")
                  }
                >
                  <span className="casino-odds">
                    {" "}
                    {getOddForEntity("BIG", casinoData, true)}
                  </span>
                </div>
              </div>
            </div>
            <div className="sicbo-bottom">
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">
                  5:1 Two Dice
                </div>
                <div className="sicbo-cube-box-group">
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                      alt="Dice 1"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                      alt="Dice 2"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                      alt="Dice 1"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                      alt="Dice 3"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                      alt="Dice 1"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                      alt="Dice 4"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                      alt="Dice 1"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                      alt="Dice 5"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                      alt="Dice 1"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                      alt="Dice 6"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                      alt="Dice 2"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                      alt="Dice 3"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                      alt="Dice 2"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                      alt="Dice 4"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                      alt="Dice 2"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                      alt="Dice 5"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                      alt="Dice 2"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                      alt="Dice 6"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                      alt="Dice 3"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                      alt="Dice 4"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                      alt="Dice 3"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                      alt="Dice 5"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                      alt="Dice 3"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                      alt="Dice 6"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                      alt="Dice 4"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                      alt="Dice 5"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                      alt="Dice 4"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                      alt="Dice 6"
                    />
                  </div>
                  <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                      alt="Dice 5"
                    />
                    <img
                      src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                      alt="Dice 6"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-xl-none w-100">
            <div className="sicbo-top">
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">
                  1:1 Lose to Any Triple
                </div>
                <div className="sicbo-cube-box-group">
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Small</div>
                    <div className="sicbo-box-value">4-10</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>ODD</div>
                    <div className="sicbo-box-value">1:1</div>
                  </div>
                </div>
              </div>
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">30:1</div>
                <div className="sicbo-cube-box-group">
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Any Triple</div>
                  </div>
                </div>
              </div>
              <div className="sicbo-cube-box-container">
                <div className="sicbo-top-box sicbo-title-box">
                  1:1 Lose to Any Triple
                </div>
                <div className="sicbo-cube-box-group">
                  <div className={`sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd ${casinoData?.data?.response?.autoTime < 5
                    ? "suspended-box"
                    : ""
                    }`}>
                    <div>EVEN</div>
                    <div

                      onClick={() =>
                        setBet("Even", casinoData, dispatch, "back")
                      }
                    >
                      <span className="casino-odds">
                        {" "}
                        {getOddForEntity("Even", casinoData, true)}
                      </span>
                    </div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box sicbo-middle-top-box-odd">
                    <div>Big</div>
                    <div className="sicbo-box-value ">11:17</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sicbo-middle">
              <div className="sicbo-middle-left">
                <div className="sicbo-cube-box-container">
                  <div className="sicbo-top-box sicbo-title-box">
                    8:1 Each Double
                  </div>
                  <div className="sicbo-cube-box-group">
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-double">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                    </div>
                  </div>
                </div>
                <div className="sicbo-cube-box-container">
                  <div className="sicbo-top-box sicbo-title-box">
                    150:1 Each Tripple
                  </div>
                  <div className="sicbo-cube-box-group">
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                        alt="Dice 1"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                        alt="Dice 2"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                        alt="Dice 3"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                        alt="Dice 4"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                        alt="Dice 5"
                      />
                    </div>
                    <div className="sicbo-cube-box sicbo-square-box sicbo-cube-tripple">
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                      <img
                        src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                        alt="Dice 6"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="sicbo-middle-right">
                <div className="sicbo-middle-top-row">
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>4</div>
                    <div className="sicbo-box-value ">50:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>5</div>
                    <div className="sicbo-box-value ">20:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>6</div>
                    <div className="sicbo-box-value ">15:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>7</div>
                    <div className="sicbo-box-value ">12:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>8</div>
                    <div className="sicbo-box-value ">8:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>9</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>10</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>11</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>12</div>
                    <div className="sicbo-box-value ">6:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>13</div>
                    <div className="sicbo-box-value ">8:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>14</div>
                    <div className="sicbo-box-value ">12:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>15</div>
                    <div className="sicbo-box-value ">15:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>16</div>
                    <div className="sicbo-box-value ">20:1</div>
                  </div>
                  <div className="sicbo-middle-top-box sicbo-square-box">
                    <div>17</div>
                    <div className="sicbo-box-value ">50:1</div>
                  </div>
                </div>
                <div className="sicbo-bottom">
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      5:1 Two Dice
                    </div>
                    <div className="sicbo-cube-box-group">
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-combination">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="sicbo-middle-middle-row">
                  <div className="sicbo-cube-box-container">
                    <div className="sicbo-top-box sicbo-title-box">
                      <span>1:1 on Sinlge</span>
                      <span>2:1 on Double</span>
                      <span>3:1 on Tripple</span>
                    </div>
                    <div className="sicbo-cube-box-group">
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice1.png"
                          alt="Dice 1"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice2.png"
                          alt="Dice 2"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice3.png"
                          alt="Dice 3"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice4.png"
                          alt="Dice 4"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice5.png"
                          alt="Dice 5"
                        />
                      </div>
                      <div className="sicbo-cube-box sicbo-square-box sicbo-cube-single">
                        <img
                          src="https://g1ver.sprintstaticdata.com/v50/static/front/img/dice6.png"
                          alt="Dice 6"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="casino-last-result-title">
              <span>Last Result</span>
              <span>
                <a href="/casino-results/sicbo">View All</a>
              </span>
            </div>
            <div className="casino-last-results">
              <span className="result">6</span>
              <span className="result">14</span>
              <span className="result">8</span>
              <span className="result">11</span>
              <span className="result">7</span>
              <span className="result">7</span>
              <span className="result">8</span>
              <span className="result">7</span>
              <span className="result">16</span>
              <span className="result">11</span>
            </div> */}
      </div>
      {/* </div> */}
      <div className="d-none">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Matched Bet</th>
                <th className="text-end">Odds</th>
                <th className="text-end">Stake</th>
              </tr>
            </thead>
            <tbody />
          </table>
        </div>
      </div>
      {/* </div> */}
      {/* </div> */}
      {/* <div className="sidebar right-sidebar casino-right-sidebar sticky">
      <div className="sidebar-box my-bet-container">
        <div className="sidebar-title">
          <h4>My Bet</h4>
        </div>
        <div className="my-bets">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Matched Bet</th>
                  <th className="text-end">Odds</th>
                  <th className="text-end">Stake</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
    </div> */}
      {/* </div> */}
    </CasinoPage>

  )
}
